import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";

// Downloads a combined CSV of every service in the selected Lines of Business
// from the v2 endpoint. Uses a direct fetch (not an RTK Query hook) because the
// response is a file, not JSON, and we stream it straight to a browser download.
const filenameFromDisposition = (header: string | null): string => {
  const match = header?.match(/filename="?([^"]+)"?/);
  return match?.[1] ?? "lines-of-business-tasks.csv";
};

export const useDownloadLinesOfBusinessCsv = () => {
  const token = useSelector((state: RootState) => state.auth.token);
  const [isDownloading, setIsDownloading] = useState(false);

  const download = async (ids: string[]): Promise<void> => {
    setIsDownloading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SCOPESTACK_API_HOST}/v2/line-of-businesses/download`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/vnd.api+json",
            Accept: "text/csv",
          },
          body: JSON.stringify({ filter: { ids } }),
        }
      );
      if (!res.ok) {
        throw new Error(`Download failed (${res.status})`);
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filenameFromDisposition(
        res.headers.get("Content-Disposition")
      );
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } finally {
      setIsDownloading(false);
    }
  };

  return { download, isDownloading };
};

export default useDownloadLinesOfBusinessCsv;
